// extracted by mini-css-extract-plugin
export var aircallIframe = "_ic-3";
export var fabContainer = "_ic-5";
export var fabRinging = "_ic-6";
export var loadingOverlay = "_ic-4";
export var pulse = "_ic-7";
export var widgetContent = "_ic-2";
export var widgetPanel = "_ic-0";
export var widgetPanelExpanded = "_ic-1";